module.exports = wp.blockEditor;